import RainItem from './RainItem';
import React from 'react';

//'38', '38', '40', '40', '37', '39', '37', '39', '66', '65',
const KONAMI_CODE = [ '38', '38', '40', '40', '37', '39', '37', '39', '66', '65','13'];

export class Konami {
  private successArray: boolean[] = [];

  constructor() {
    this.resetSuccessArray();
  }

  private resetSuccessArray() {
    this.successArray = [];
    KONAMI_CODE.forEach((keyPress: string) => {
      this.successArray.push(false);
    });
  }

  public renderRainfall() {
    let rainArray: number[] = [];
    for (let i = 0; i <= 80; i++)
      rainArray.push(Math.floor(Math.random() * 350));

    const getRainFall = () => {
      return rainArray.map((plusWidth: number) => {
        return <RainItem
          size={plusWidth}
          top={Math.floor(Math.random() * 450) + 50}
          rotationClass={`spin-animation-${Math.floor(Math.random() * 3) + 1}`}
        />;
      });
    };

    return (
      <div className={'konami-rain-container'}>
        {getRainFall()}
      </div>
    );
  }

  public dispatchKeyKode(keyPress: string) {
    if (!this.successArray[0]) {
      this.goodKeyPress(0, keyPress);
    } else {
      let found = false;
      this.successArray.forEach((position: boolean, i) => {
        if (!found) {
          if (!position) {
            if (this.goodKeyPress(i, keyPress)) {
              found = true;
            } else {
              this.resetSuccessArray();
            }
          }
        }
      });
    }

    //Checks if the user has found the good combination
    let found = false;
    if (this.gotCodeRight()) {
      this.resetSuccessArray();
      found = true;
    }
    return found;
  }

  public animate() {
    let rainContainerClass = document.getElementsByClassName('konami-rain-container');
    let rainContainerItem: any = rainContainerClass[0];
    rainContainerItem.style.display = 'flex';
    setTimeout(function() {
      rainContainerItem.style.display = 'none';
    }, 10000);
  }

  private goodKeyPress(position: number, keyPress: string) {
    if (KONAMI_CODE[position] === keyPress)
      this.successArray[position] = true;

    return KONAMI_CODE[position] === keyPress;
  }

  private gotCodeRight() {
    return this.successArray.filter((x: boolean) => x).length === this.successArray.length;
  }
}